import React, { useMemo } from 'react'
import { useLocation } from 'react-router-dom'

import { Breadcrumb, NavTab, Template } from '@components'
import { LinkManager } from '@utils/helpers'
import { createBreadcrumbLink, useCreateBreadcrumb } from '@utils/hooks'

import ListClients from './ListClients'
import ListClientsActive from './ListClientsActive'
import ListSuspiciousDownloads from './ListSuspiciousDownloads'

function Clients() {
	const { pathname } = useLocation()

	const baseUrl = '/clientes'

	const allPages = useMemo(() => {
		return [
			createBreadcrumbLink('Clientes', baseUrl, 1),
			createBreadcrumbLink('Clientes Ativos', `${baseUrl}/ativos`, 2),
			createBreadcrumbLink('Downloads na Semana', `${baseUrl}/downloads`, 2),
		]
	}, [])

	const pages = useCreateBreadcrumb(allPages)

	const linkManager = new LinkManager(baseUrl)

	function createLink(to: string) {
		return linkManager.create(to)
	}

	const links = [
		{ title: 'Clientes', to: createLink('') },
		{ title: 'Clientes Ativos', to: createLink('/ativos') },
		{
			title: 'Downloads na Semana',
			to: createLink('/downloads'),
		},
	]

	const components = {
		[createLink('')]: <ListClients />,
		[createLink('/ativos')]: <ListClientsActive />,
		[createLink('/downloads')]: <ListSuspiciousDownloads />,
	}

	return (
		<>
			<Template>
				<Breadcrumb pages={pages} />

				<div className='flex items-end justify-between '>
					<NavTab links={links} />
				</div>
				{components[pathname]}
			</Template>
		</>
	)
}

export default Clients
